(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bmg-cookie-preferences"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bmg-cookie-preferences')) {
    customElements.define('bmg-cookie-preferences', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.button = this.querySelector('button');
        this.fallback = this.querySelector('.bmg-cookie-preferences__fallback');
        if (!this.button || !this.fallback) return;
        this.controller = new AbortController();
        this.button.hidden = false;
        this.fallback.hidden = true;
        this.button.addEventListener('click', () => this.openPreferences(), {
          signal: this.controller.signal
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.focusObserver?.disconnect();
      }

      async waitForBanner() {
        const deadline = Date.now() + 5000;
        while (this.isConnected && Date.now() < deadline) {
          if (typeof window.privacyBanner?.showPreferences === 'function') {
            return window.privacyBanner;
          }
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        throw new Error('Cookie preferences unavailable');
      }

      async openPreferences() {
        if (this.opening) return;
        this.opening = true;
        this.fallback.hidden = true;
        this.button.setAttribute('aria-busy', 'true');
        let timeout;
        try {
          const banner = await this.waitForBanner();
          if (!this.isConnected) return;
          await Promise.race([
            banner.showPreferences(),
            new Promise((_, reject) => {
              timeout = setTimeout(() => reject(new Error('Cookie preferences timed out')), 5000);
            })
          ]);
          if (this.isConnected) this.restoreFocusWhenClosed();
        } catch {
          if (this.isConnected) {
            this.fallback.hidden = false;
            this.fallback.focus();
          }
        } finally {
          clearTimeout(timeout);
          this.button.removeAttribute('aria-busy');
          this.opening = false;
        }
      }

      restoreFocusWhenClosed() {
        this.focusObserver?.disconnect();
        const modal = document.activeElement?.closest('dialog, [role="dialog"]');
        if (!modal || this.contains(modal)) return;
        this.focusObserver = new MutationObserver(() => {
          const visible = modal.isConnected && modal.getClientRects().length > 0 &&
            modal.getAttribute('aria-hidden') !== 'true' &&
            getComputedStyle(modal).visibility !== 'hidden';
          if (visible) return;
          this.focusObserver.disconnect();
          requestAnimationFrame(() => {
            const active = document.activeElement;
            if (this.isConnected && (active === document.body || modal.contains(active))) {
              this.button.focus();
            }
          });
        });
        this.focusObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'open']
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
